export const initialValues = {
  name: "",
  member_price: "",
  non_member_price: "",
  is_active: 0,
};
